/**
 * Menu controller.
 *
 * This class controls the site menu and search functions.
 */
import Common from './common';

 // Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Menu
 */
export default class Menu {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the class's methods.
     */
    cache() {

        // Site header.
        this.siteHeader = document.getElementById( 'js-site-header' );

        // Dark overlay.
        this.darkOverlay = document.getElementById( 'js-dark-overlay' );

        // Menu toggle buttons.
        this.menuToggler      = document.getElementById( 'js-main-menu-toggle' );
        this.menuCloseToggler = document.getElementById( 'js-main-menu-toggle-close' );

        // Main menu.
        this.menu = document.getElementById( 'js-main-menu' );

        // Each top level menu item that has children.
        this.menuParents = $( '.menu-item-has-children' );

        // Each submenu inside the top level menu items that have children.
        if ( this.menuParents ) {
            this.menuSubMenus = Common.childrenFromEach( this.menuParents, '.sub-menu' );
        }

        // Search elements.
        this.searchField = document.getElementById( 'js-search-field-container' );
        this.searchFieldInput = document.getElementById( 'js-search-field-input' );
        this.openSearch  = document.getElementById( 'js-search-toggle-open' );
        this.closeSearch = document.getElementById( 'js-search-toggle-close' );
        this.addSearch   = document.getElementById( 'addsearch-results' );
    }

    /**
     * All events of the menus.
     *
     * @return {void}
     */
    events() {

        const thisClass = this;

        /**
         * Close search with esc key and set aria correct states.
         */
        $( document ).on( 'keyup', function( event ) {
            if ( event.keyCode == 27 && thisClass.searchField.classList.contains( 'search--open' ) ) {

                // Set hidden to true for search field.
                thisClass.searchField.setAttribute( 'hidden', true );

                // Close menu and show correct search toggle button.
                thisClass.searchField.classList.remove( 'search--open' );
                thisClass.openSearch.classList.add( 'search--closed' );
                thisClass.closeSearch.classList.remove( 'search--open' );

                // Set aria-expanded false to search toggle buttons.
                thisClass.openSearch.setAttribute( 'aria-expanded', 'false' );
                thisClass.closeSearch.setAttribute( 'aria-expanded', 'false' );

                // Remove class from body.
                document.body.classList.remove( 'search--open' );

                // Remove dark overlay.
                thisClass.darkOverlay.classList.remove( 'menu--open' );
            }
        });

         // Close sub-menus when clicked outside.
         $( document ).mouseup( function( e ) {

            // Get opened menu.
            const openedMenu = $( '.sub-menu--open' );

            const searchField = $( '#js-search-field-container' );

            // Get gallery page categories container and filter button.
            const galleryCategories = $( '#js-gallery-categories' );
            const galleryFilter     = $( '#js-gallery-categories-filter' );

            //Get dark overlay.
            const darkOverlay = $( '#js-dark-overlay' );

            // If target is not sub-menu or its descendant & if search field is not open.
            if ( ! openedMenu.is( e.target ) && ! galleryFilter.is( e.target ) && openedMenu.has( e.target ).length === 0 && ! searchField.hasClass( 'search--open' ) ) {

                // Remove menu open class & current item class.
                openedMenu.removeClass( 'sub-menu--open' );
                openedMenu.removeClass( 'current-menu-item' );

                // Hide dark overlay.
                darkOverlay.removeClass( 'menu--open' );

                // Set hidden & aria-expanded attributes.
                $( '.sub-menu' ).prop( 'hidden', true );
                $( '.js-toggle-submenu' ).attr( 'aria-expanded', 'false' );

                // Close gallery categories menu.
                galleryCategories.removeClass( 'open' );
            }
        });

        // Toggle submenus open and closed.
        // Pass the list parent item of each iteration to
        // the functions scope.
        this.menuParents.each( ( index, menuParent ) => {

            // Get the menu link of the list item.
            const menuLink = $( menuParent ).children( '.js-toggle-submenu' );

            // Bind a click handler to each menu parent's link.
            $( menuLink ).on( 'click', ( e ) =>  {

                // Change aria-expanded state on parent link.
                if ( $( e.target ).hasClass( 'js-toggle-submenu' ) ) {

                     // Call the sub menu toggler method with the event and the
                    // clicked list parent item.
                    this.toggleSubMenu( e, menuParent );
                }
            });
        });
    }

    /**
     * Toggles main menu open/close.
     * @return {void}
     */
    toggleMainMenu() {

        // Return early if missing required elements.
        if ( ! this.menuToggler || ! this.menuCloseToggler ||  ! this.menu ) {
            return;
        }

        // Scroll to top when toggle menu button is clicked.
        $( 'html, body' ).animate({ scrollTop: 0 }, 0 );

        // Toggle active states.
        this.siteHeader.classList.toggle( 'menu--open' );
        this.menu.classList.toggle( 'menu--open' );

        this.darkOverlay.classList.remove( 'menu--open' );

        this.menuToggler.classList.toggle( 'menu--closed' );
        this.menuCloseToggler.classList.toggle( 'menu--open' );

        // Get the toggler's aria-expanded current state and set a new opposite state to it.
        // Also set the opened container's aria-hidden state to the new value's opposite.
        const ariaExpandedState = this.menuToggler.getAttribute( 'aria-expanded' ) === 'false' ? true : false;

        this.menuToggler.setAttribute( 'aria-expanded', ariaExpandedState );
        this.menuCloseToggler.setAttribute( 'aria-expanded', ariaExpandedState );

         // Show/hide dark overlay.
         if ( this.siteHeader.classList.contains( 'menu--open' ) ) {
            this.darkOverlay.classList.add( 'menu--open' );
        } else {
            this.darkOverlay.classList.remove( 'menu--open' );
        }

        const upperThis = this;

        // Close with esc key and set aria states.
        $( document ).on( 'keyup', function( event ) {
            if ( event.keyCode == 27 ) {

                // If menu is open.
                if ( upperThis.menu.classList.contains( 'menu--open' ) ) {

                    // Close menu and show correct menu toggle button.
                    upperThis.menu.classList.toggle( 'menu--open' );
                    upperThis.menuToggler.classList.toggle( 'menu--closed' );
                    upperThis.menuCloseToggler.classList.toggle( 'menu--open' );

                    // Set aria-expanded false to menu toggle buttons.
                    upperThis.menuToggler.setAttribute( 'aria-expanded', 'false' );
                    upperThis.menuCloseToggler.setAttribute( 'aria-expanded', 'false' );

                    // Remove dark overlay.
                    upperThis.darkOverlay.classList.remove( 'menu--open' );
                }
            }
        });
    }

    /**
     * Toggles the sub menus open and closed
     * @return {void}
     */
    toggleSubMenu( e, menuParent ) {

        // The clicked element.
        const clickedElement = e.target;

        // Dark overlay.
        const darkOverlay = this.darkOverlay;

        // Get sub-menu ul.
        const subMenu = menuParent.getElementsByTagName( 'ul' )[0];

        // Get aria-expanded state.
        const ariaExpandedState = e.target.getAttribute( 'aria-expanded' ) === 'false' ? true : false;

        // Show/hide dark overlay.
        if ( clickedElement.parentNode.classList.contains( 'sub-menu--open' ) ) {
            darkOverlay.classList.remove( 'menu--open' );
        } else {
            darkOverlay.classList.add( 'menu--open' );
        }

        // Remove sub-menu--open from other parent elements and set correct aria-expanded state.
        this.menuParents.each( function() {
            if ( this !== clickedElement.parentNode ) {
                this.classList.remove( 'current-menu-item' );
                this.classList.remove( 'sub-menu--open' );
                this.getElementsByTagName( 'a' )[0].setAttribute( 'aria-expanded', 'false' );
            } else {
               clickedElement.parentNode.classList.toggle( 'current-menu-item' );
               clickedElement.parentNode.classList.toggle( 'sub-menu--open' );
               clickedElement.setAttribute( 'aria-expanded', ariaExpandedState );
            }
        });

        // Remove sub-menu--open from other sub-menu elements.
        this.menuSubMenus.forEach( ( submenu ) => {
            if ( submenu !== subMenu ) {
                submenu.classList.remove( 'sub-menu--open' );
            }
        });

        // If sub-menu is already open.
        if ( subMenu.classList.contains( 'sub-menu--open' ) ) {
            subMenu.classList.toggle( 'sub-menu--open' );
            subMenu.setAttribute( 'hidden', true );
        } else {
            subMenu.classList.toggle( 'sub-menu--open' );
            subMenu.setAttribute( 'hidden', false );
        }

        // Close with esc key and set aria states.
        $( document ).on( 'keyup', function( event ) {
            if ( event.keyCode == 27 ) {

                // If sub-menu is open.
                if ( subMenu.classList.contains( 'sub-menu--open' ) ) {

                    // Close sub-menu.
                    subMenu.classList.toggle( 'sub-menu--open' );
                    clickedElement.closest( 'li' ).classList.toggle( 'sub-menu--open' );

                    // Set aria-expanded false parent link & hidden true to sub-menu.
                    subMenu.setAttribute( 'hidden', true );
                    clickedElement.setAttribute( 'aria-expanded', 'false' );

                    // Hide dark overlay.
                    darkOverlay.classList.toggle( 'menu--open' );
                }
            }
        });
    }

    /**
     * Toggle search field visibility.
     *
     * @param {objec} e Event.
     * @return {void}
     */
    toggleSearch( e ) {

        // Return early if missing required elements.
        if ( ! this.closeSearch || ! this.openSearch || ! this.searchField ) {
            return;
        }

        // Toggle search field.
       if ( this.searchField.classList.contains( 'search--open' ) ) {
            this.searchField.classList.remove( 'search--open' );
            document.body.classList.remove( 'search--open' );
        } else {
            this.searchField.classList.add( 'search--open' );
            document.body.classList.add( 'search--open' );
        }

        // Toggle dark overlay.
        if ( e.target.parentNode === this.openSearch ) {
            this.darkOverlay.classList.add( 'menu--open' );
        } else if ( e.target.parentNode === this.closeSearch ) {
            this.darkOverlay.classList.remove( 'menu--open' );
        }

        // Get the toggler's aria-expanded current state.
        const ariaExpandedState = this.openSearch.getAttribute( 'aria-expanded' ) === 'false';

        // Set correct aria-expanded states to search togglers.
        this.openSearch.setAttribute( 'aria-expanded', ariaExpandedState );
        this.closeSearch.setAttribute( 'aria-expanded', ariaExpandedState );

        // Set/unset hidden to search field container.
        if ( this.searchField.classList.contains( 'search--open' ) ) {
            this.searchField.setAttribute( 'hidden', false );

            // Set focus to search field.
            this.searchFieldInput.focus();
        } else {
            this.searchField.setAttribute( 'hidden', true );
        }
    }

    /**
     * Run when the document is ready.
     *
     * @return {void}
     */
    docReady() {
        this.cache();
        this.events();
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/menu.js